import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import React from 'react';
import styles from './PositivesNegativesList.mscss';

interface OwnProps {
    positives: string[];
    negatives: string[];
    className?: string;
}

type Props = OwnProps;

export const PositivesNegativesList: React.FunctionComponent<Props> = React.memo(({
    positives, negatives, className,
}) => {
    return (
        <div className={cx(styles.PositivesNegativesList, className)}>
            {positives && positives.length > 0 && (
                <ul className={styles.PositivesNegativesList__positivesList}>
                    {positives.map((point, index) => {
                        return (
                            <li className={styles.PositivesNegativesList__positivesList__listItem} key={index}>
                                <FontAwesomeIcon
                                    icon={faPlusCircle}
                                    className={styles.PositivesNegativesList__positivesList__listItem__icon}
                                />
                                {point}
                            </li>
                        );
                    })}
                </ul>
            )}
            {negatives && negatives.length > 0 && (
                <ul className={styles.PositivesNegativesList__negativesList}>
                    {negatives.map((point, index) => {
                        return (
                            <li className={styles.PositivesNegativesList__negativesList__listItem} key={index}>
                                <FontAwesomeIcon
                                    icon={faMinusCircle}
                                    className={styles.PositivesNegativesList__negativesList__listItem__icon}
                                />
                                {point}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
});

PositivesNegativesList.displayName = 'PositivesNegativesList';
